// export HelpCenterBucketsRoutes from './bucket-routes';
import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const LazyHelpCenterBucketsRoutes = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "help-center-bucket-routes" */ './bucket-routes')),
});
